/**
 * Convert the Build-session suggestion stock into the small, ordered units
 * consumed by the session writer. Semicolons are the only delimiter so the
 * user can keep commas and sentence punctuation inside one goal/theme.
 */
export function parseSuggestionStock(value) {
  const values = Array.isArray(value) ? value : String(value ?? "").split(";");
  return values
    .map((item) => String(item ?? "").trim())
    .filter(Boolean);
}

export function formatSuggestionStock(value) {
  return parseSuggestionStock(value).join("; ");
}

